import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";
import { Button } from "./ui/button";

export default function Header({ onBookClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []); // setScrolled is stable; onScroll is defined inside the effect

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setMenuOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#0A0A0A]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="logo-btn"
          className="flex items-center gap-2 group"
        >
          <Sparkles className="w-5 h-5 text-[#FF2079] group-hover:rotate-12 transition-transform" />
          <span className="font-display text-2xl text-white tracking-tight">
            Pink<span className="text-[#FF2079]">Glow</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {[
            { id: "services", label: "Services" },
            { id: "gallery", label: "Gallery" },
            { id: "promotions", label: "Promotions" },
            { id: "booking", label: "Book" },
          ].map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}-btn`}
              onClick={() => scrollTo(item.id)}
              className="text-[11px] tracking-[0.28em] uppercase text-[#A09CA3] hover:text-white transition-colors"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="text-[11px] tracking-[0.28em] uppercase text-[#A09CA3] hover:text-[#FF2079] transition-colors"
          >
            Admin
          </Link>
        </nav>

        <div className="hidden md:block">
          <Button
            data-testid="header-book-btn"
            onClick={onBookClick}
            className="pink-glow-btn bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm px-6 h-10 text-[11px] tracking-[0.28em] uppercase"
          >
            Reserve
          </Button>
        </div>

        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-white/5 bg-[#0A0A0A]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {["services", "gallery", "promotions", "booking"].map((id) => (
              <button
                key={id}
                data-testid={`mobile-nav-${id}-btn`}
                onClick={() => scrollTo(id)}
                className="text-left text-sm tracking-widest uppercase text-[#A09CA3]"
              >
                {id}
              </button>
            ))}
            <Link
              to="/admin"
              data-testid="mobile-nav-admin-link"
              className="text-left text-sm tracking-widest uppercase text-[#FF2079]"
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
